/* eslint-disable eqeqeq */
import React, { useEffect, useLayoutEffect, useState } from "react";

/** Components */
import {
  FormControlLabel,
  Checkbox,
  Button,
  TableBody,
  Paper,
  MenuItem,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Table,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import RenderTreeMenu from "../../commons/renderTreeMenu.component";
import InvoiceViewer from "../commons/InvoiceViewer.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icon */

/** Api && Function */
import { createCI, getBact, getBanks, getBactById, getBankById, getCIInvoice, getCustomers, getLoadingType, getCHKSubso } from "../../../services/api";
import { convertTreeDataToArrayData, deepCopy } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { withStyles } from "@material-ui/core/styles";
import { usePagination, useValueRef } from "../../commons/customHook";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

/** Base Component */
const ColorlibConnector = withStyles({
  //tao react component chi co style
  completed: {
    "& $line": {
      backgroundImage: "linear-gradient(blue, blue)",
    },
  },
  active: {
    "& $line": {
      backgroundImage: "linear-gradient(lightblue, lightblue)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

/** Step config */
const stepConfig = [
  {
    label: "Chọn khách hàng",
  },
  {
    label: "Chọn hóa đơn",
  },
  {
    label: "Kiểm tra và xác nhận",
  },
];

export default function CreateCI() {
  /** Constructor */
  const dispatch = useDispatch();

  const [input, setInput] = useState({
    period_start_time: moment(Date.now()).format("YYYY-MM-DD"),
    period_end_time: moment(Date.now()).format("YYYY-MM-DD"),
    effective_time: moment(Date.now()).format("YYYY-MM-DD"), // ngay hieu luc
    end_effective_time: moment(Date.now()).format("YYYY-MM-DD"), // ngay het han
    customer: null,
    bank: null,
    bank_id: null,
    bact_id: null,

    invoices: [], // Array of selected invoice_id

    /** Type
     *  0: Commercial Invoice - USD
     *  1: Payment Notice - VND
     *  2: Proforma Invoice - USD
     *  3: loadingtype_id = 0 - Commercial Invoice - USD
     */

    type: 0,
    ciproducts: [],
    code: "",
    note: "",
    currency: null,
    loadingtype: null,

    /** Add for Ship */
    ciinfos: {
      contract_no: "2025/PA-TOTAL dated 31 Dec 2024",
      port_loading: "Nha Be Terminal, HCMC, Vietnam",
      port_discharge: "PHUM RHSOM, CAMBODIA",
      delivery_term: "D.A.P - PHUM RHSOM, CAMBODIA",
    },
  });

  const [dglShipInfo, setdglShipInfo] = useState(false);

  const [step, setStep] = useState(0);
  const getStep = () => {
    switch (step) {
      case 0:
        return <Step0 initialData={input} onSubmit={handleStep0Submit} />;
      case 1:
        return <Step1 initialData={input} onSubmit={handleStep1Submit} goBack={setStep} />;
      case 2:
        return <Step2 initialData={input} onSubmit={handleStep2Submit} goBack={setStep} />;
      default:
        return <Step0 />;
    }
  };
  const handleStep0Submit = (data) => {
    setInput(data);
    setStep(1);
  };

  const handleStep1Submit = (data) => {
    setInput(data);

    if (data?.loadingtype_id === 5) {
      setdglShipInfo(true);
    } else {
      setStep(2);
    }
  };

  /** Add Step for Ship */

  const handleAddInforShip = () => {
    if (
      input?.ciinfos?.delivery_term &&
      input?.ciinfos?.contract_no &&
      input?.ciinfos?.port_discharge &&
      input?.ciinfos?.delivery_term !== null &&
      input?.ciinfos?.contract_no !== null &&
      input?.ciinfos?.port_discharge !== null
    ) {
      /** Check price of 1st invoice to get Mop, Prem, Unit */

      setInput((prev) => ({
        ...prev,
        ciinfos: {
          ...prev.ciinfos,
          price_date: input?.invoices[0]?.valid_date,
          price_no: input?.invoices[0]?.price,
          price_Mops: input?.invoices[0]?.price_Mops,
          price_premium: (input?.invoices[0]?.price - input?.invoices[0]?.price_Mops).toPrecision(5),
          price_unit: input?.invoices[0]?.unit,
          // currency: input?.invoices[0]?.currency,
        },
      }));

      setdglShipInfo(false);
      setStep(2);
    }
  };

  const handleStep2Submit = (data) => {
    let ciproducts = data?.ciproducts.filter((i) => i.isCreateBK !== false);
    let object = {
      period_start_time: data.period_start_time,
      period_end_time: data.period_end_time,
      effective_time: data.effective_time,
      end_effective_time: data.end_effective_time,
      customer_id: data.customer?.id,
      bank_id: data.bank?.id,
      invoices: data.invoices.map((item) => item.id),
      type: data.type,
      ciproducts,
      code: data.code,
      note: data.note,
      gallon: ciproducts.reduce((p, c) => p + c.gallon, 0),
      mt: ciproducts.reduce((p, c) => p + c.mt, 0), //mac dinh
      amount: ciproducts.reduce((p, c) => p + c.amount, 0),
      vat: ciproducts.reduce((p, c) => p + (c.vat <= 0 ? 0 : c.vat), 0),
      total: ciproducts.reduce((p, c) => p + c.total, 0),
      lit: ciproducts.reduce((p, c) => p + c.lit, 0),
      kg: ciproducts.reduce((p, c) => p + c.kg, 0),
      quantity: ciproducts.every((i, index, array) => i.unit == array[0].unit) ? ciproducts.reduce((p, c) => p + c.quantity, 0) : ciproducts.reduce((p, c) => p + c.mt, 0),
      unit: ciproducts.every((i, index, array) => i.unit == array[0].unit) ? ciproducts[0].unit : "MT",
      currency: data.bact?.currency,
      currency_id: data.bact?.currency_id,
      period: data.period,
      bact_id: data.bact?.id,
      loadingtype_id: data.loadingtype_id,
      status: 1, // mac dinh

      // Add for CI Ship
      // contract_no: data.contract_no,
      // delivery_term: data.delivery_term,
      // port_loading: data.port_loading,
      // port_discharge: data.port_discharge,
      // price_date: data.price_date,
      // price_no: data.price_no,
      // price_Mops: data.price_Mops,
      // price_premium: data.price_premium,
      // price_unit: data.price_unit,
      ciinfos: data.ciinfos,
    };
    return createCI(object);
  };

  /** Set Title */
  useEffect(() => {
    dispatch(setHeaderTitle("TẠO THÔNG BÁO THU TIỀN KHÁCH HÀNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ paddingTop: 20 }}>
      <Stepper connector={<ColorlibConnector />} activeStep={step} style={{ marginBottom: 20 }}>
        {stepConfig.map((step, index) => (
          <Step key={index}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {getStep()}
      <EditShipInfoDialog open={dglShipInfo} initialData={input} onSave={setInput} onClose={handleAddInforShip} />
    </div>
  );
}

/** Select Customer */
const Step0 = ({ initialData, onSubmit }) => {
  const [t] = useTranslation();
  const [input, setInput] = useState(initialData);
  const [error, setError] = useState("");
  useLayoutEffect(() => {
    try {
      if (moment(input.period_end_time).month() !== moment(input.period_start_time).month() || moment(input.period_end_time).year() !== moment(input.period_start_time).year()) {
        setError("Ngày bắt đầu và ngày kết thúc phải cùng tháng và năm.");
        return;
      }
      if (Date.parse(input.period_end_time) < Date.parse(input.period_start_time)) {
        setError("Ngày bắt đầu phải nhỏ hơn ngày kết thúc.");
        return;
      }
      if (Date.parse(input.end_effective_time) < Date.parse(input.effective_time)) {
        setError("Ngày hiệu lực phải nhỏ hơn ngày hết hạn.");
        return;
      }
      setError("");
    } catch (error) {}
  }, [input]);

  useEffect(() => {
    if (input.bank_id !== null) {
      getBankById(input.bank_id).then((res) => {
        if (res.code !== 200) return;
        setInput((prev) => ({ ...prev, bank: res.data }));
      });
    }
  }, [input.bank_id]);

  useEffect(() => {
    if (input.bact_id !== null) {
      getBactById(input.bact_id).then((res) => {
        if (res.code !== 200) return;
        // eslint-disable-next-line eqeqeq
        setInput((prev) => ({ ...prev, bact: res.data, type: res.data.currency == "USD" ? 0 : 1 }));
      });
    }
  }, [input.bact_id]);

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gridGap: 10, marginTop: 30, padding: "0 10px" }}>
        <FilterBy
          value={input.customer}
          onChange={(e, newvalue) => setInput((prev) => ({ ...prev, customer: newvalue, bank_id: newvalue?.bank_id, bact_id: newvalue?.bact_id }))}
          getDataFunc={() => getCustomers({ status: 1 })}
          label={t("Khách hàng")}
        />
        <FilterBy
          value={input.bank}
          disabled={true}
          onChange={(e, newvalue) => setInput((prev) => ({ ...prev, bank: newvalue, bact: null }))}
          getDataFunc={() => getBanks({ status: 1 })}
          label={t("Ngân hàng")}
          getOptionLabel={(option) => `${option.id} - ${option.vi_name}`}
        />
        <FilterBy
          disabled={!input.bank}
          value={input.bact}
          onChange={(e, newvalue) => setInput((prev) => ({ ...prev, bact: newvalue, type: newvalue ? (newvalue.currency == "USD" ? 0 : 1) : 0 }))}
          getDataFunc={() => getBact({ status: 1, bank_id: input.bank?.id })}
          triggerGetDataFunc={input.bank}
          getDataDependencies={[input.bank]}
          label={t("Tài khoản ngân hàng")}
          getOptionLabel={(option) => `${option.act_number} - ${option.currency}`}
          filter={(option) => option.status == "ACTIVATED"}
        />
        <FilterBy
          value={input.loadingtype}
          onChange={(e, newvalue) => setInput((prev) => ({ ...prev, loadingtype: newvalue, loadingtype_id: newvalue?.id, end_effective_time: moment(Date.now()).format("YYYY-MM-DD") }))}
          getOptionLabel={(option) => option.name}
          getDataFunc={() => getLoadingType({ status: 1 }).then((res) => (res.code == 200 ? { ...res, data: [{ id: 0, name: "Others" }, ...res.data] } : res))}
          label={t("Loại hình bán")}
          // setDefaultFunc={option => setInput(prev => ({ ...prev, loadingtype: option.find(i => i.id == initialData.loadingtype?.id) || null }))}
          // triggerSetDefaultFunc={initialData.loadingtype}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Từ ngày")}
          value={input.period_start_time}
          onChange={(value) => setInput((prev) => ({ ...prev, period_start_time: value }))}
          sx={{ minWidth: "200px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Đến ngày")}
          value={input.period_end_time}
          onChange={(value) => setInput((prev) => ({ ...prev, period_end_time: value }))}
          sx={{ minWidth: "200px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Ngày hiệu lực")}
          value={input.effective_time}
          onChange={(value) => setInput((prev) => ({ ...prev, effective_time: value }))}
          sx={{ minWidth: "200px" }}
        />
        <TextField
          disabled
          fullWidth
          label={t("Loại")}
          select
          value={input.type}
          style={{ minWidth: "200px", textAlign: "left" }}
          onChange={(e) => setInput((prev) => ({ ...prev, type: e.target.value }))}
        >
          <MenuItem value={0}>Commercial Invoice</MenuItem>
          <MenuItem value={1}>Thông báo thu tiền hàng</MenuItem>
        </TextField>
        {input.loadingtype?.id == 0 && (
          <CustomDatePicker
            format="DD/MM/YYYY"
            label={t("Hạn thanh toán")}
            value={input.end_effective_time}
            onChange={(value) => setInput((prev) => ({ ...prev, end_effective_time: value }))}
            sx={{ minWidth: "200px" }}
          />
        )}
      </div>
      <div align="left" style={{ margin: "20px auto", padding: "0 10px" }}>
        <div style={{ margin: "0 0 5px 10px" }}>{t("Ghi chú")}:</div>
        <CKEditor
          editor={ClassicEditor}
          data={input.note}
          onChange={(e, editor) => {
            const data = editor.getData();
            setInput((prev) => ({ ...prev, note: data }));
          }}
        />
      </div>
      <div style={{ color: "red", minHeight: "30px" }}>{error}</div>
      <Button
        onClick={() => onSubmit({ ...input, invoices: [], ciproducts: [] })}
        variant="contained"
        disabled={
          !Boolean(input.bact) ||
          !Boolean(input.loadingtype) ||
          !Boolean(input.customer) ||
          !Boolean(input.period_start_time) ||
          !Boolean(input.period_end_time) ||
          !Boolean(input.effective_time) ||
          !Boolean(input.bank) ||
          Boolean(error)
        }
      >
        {t("Tiếp tục")}
      </Button>
    </div>
  );
};

/** Select invoices */
const Step1 = ({ initialData, onSubmit, goBack }) => {
  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();
  const [t] = useTranslation();
  const [data, setData] = useState(); // tree data
  const [subData, setSubData] = useState([]); // array of sub tree
  const [isAllow, setAllow] = useState(true);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const isSelectedAll = Boolean(subData.every((item) => selectedInvoices.includes(item.id)));
  const [isLoading, setLoading] = useState(true);

  useLayoutEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subData]);

  /** Get invoices
   */
  useLayoutEffect(() => {
    getCIInvoice({
      customer_id: initialData.customer?.id,
      start_date: initialData.period_start_time,
      end_date: initialData.period_end_time,
      currency_code: initialData.bact?.currency,
      loadingtype_id: initialData.loadingtype?.id,
    }).then((res) => {
      setLoading(false);
      if (res.code === 200) {
        setData(res.data);
        setSubData(convertTreeDataToArrayData(res.data));
      }
      if (res.code === 403) {
        setAllow(false);
        setSubData([]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (!data) return;
    let currentSelectedInvoiceIds = initialData.invoices.map((item) => item.id);
    setSelectedInvoices(
      convertTreeDataToArrayData(data)
        .filter((item) => currentSelectedInvoiceIds.includes(item.id))
        .map((item) => item.id)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSelectCheckBox = (id) => {
    if (selectedInvoices.includes(id)) setSelectedInvoices((prev) => prev.filter((item) => item !== id));
    else setSelectedInvoices((prev) => [...prev, id]);
  };

  const handleSelectAll = () => {
    if (isSelectedAll) {
      setSelectedInvoices((prev) => prev.filter((item) => subData.every((sub_item) => sub_item.id !== item)));
    } else {
      let newSelectedInvoices = [...selectedInvoices];
      subData.forEach((item) => {
        if (!newSelectedInvoices.includes(item.id)) newSelectedInvoices.push(item.id);
      });
      setSelectedInvoices(newSelectedInvoices);
    }
  };

  const handleSubmit = () => {
    let newCIProducts = [];
    let newTotal = {
      amount: 0,
      gallon: 0,
      vat: 0,
      mt: 0,
      lit: 0,
      kg: 0,
      total: 0,
    };
    let invoices = convertTreeDataToArrayData(data).filter((item) => selectedInvoices.includes(item.id));
    invoices.forEach((item) => {
      newTotal.amount += item.sub_amount;
      newTotal.gallon += parseFloat(item.sub_gallon) || 0;
      item.vat > 0 && (newTotal.vat += item.vat);
      newTotal.mt += item.sub_kg / 1000;
      newTotal.total += item.total;
      newTotal.lit += item.sub_lit;
      newTotal.kg += item.sub_kg;
      newTotal.quantity += parseFloat(item.sub_quantity) || 0;
      // tim nhom phu hop trong ci product, neu khong co thi tao moi
      let index = newCIProducts.findIndex(
        (product) =>
          product.airline === item.airline &&
          product.location === item.location &&
          product.de_type === item.de_type &&
          product.saletype === item.saletype &&
          item.price === product.price &&
          product.unit === item.unit
      );

      if (index !== -1) {
        newCIProducts[index].total += item.total;
        newCIProducts[index].gallon += parseFloat(item.sub_gallon) || 0;
        item.vat > 0 && (newCIProducts[index].vat += item.vat);
        /** Check if type == 0 (CI - then plus total)   */
        if (initialData.type === 0) {
          newCIProducts[index].amount += item.total;
        } else {
          newCIProducts[index].amount += item.sub_amount;
        }
        newCIProducts[index].kg += item.sub_kg;
        newCIProducts[index].quantity += parseFloat(item.sub_quantity) || 0;
        newCIProducts[index].mt += item.sub_kg / 1000;
        newCIProducts[index].lit += item.sub_lit;
        newCIProducts[index].invoices.push(item.id);
      } else {
        newCIProducts.push({
          airline: item.airline,
          airline_id: item.airline_id,
          location: item.location,
          de_type: item.de_type,
          saletype_id: item.saletype_id,
          delivery: item.hydrant_sys,
          saletype: item.saletype,
          mt: item.sub_kg / 1000 || 0,
          quantity: item.sub_quantity || 0,
          gallon: item.sub_gallon || 0,
          price: item.price, //default
          amount: initialData.type === 0 ? item.total : item.sub_amount,
          vat: item.vat,
          total: item.total,
          lit: item.sub_lit,
          kg: item.sub_kg,
          invoices: [item.id],
          period: item.period,
          organization_id: item.organization_id,
          unit: item.unit,
        });
      }
    });
    onSubmit({ ...initialData, ciproducts: newCIProducts.map((item) => ({ ...item, invoices: JSON.stringify(item.invoices), isCreateBK: false })), ...newTotal, invoices });
  };
  if (!isLoading)
    return (
      <div>
        <div style={{ display: "flex" }}>
          {/* tree */}
          <div style={{ width: "350px" }}>
            <RenderTreeMenu object={data} action={(data) => setSubData(convertTreeDataToArrayData(data))} />
          </div>
          <TableContainer component={Paper}>
            <Table>
              <TableHead style={{ backgroundColor: "lightgray" }}>
                <TableRow>
                  <TableCell align="center">ID</TableCell>
                  <TableCell align="center">{t("Ký hiệu")}</TableCell>
                  <TableCell align="center">{t("Code")}</TableCell>
                  <TableCell align="center">{t("Ngày phát hành")}</TableCell>
                  <TableCell align="center">{t("Loại hình bán")}</TableCell>
                  {initialData.loadingtype?.id == 1 && (
                    <>
                      <TableCell align="center">{t("Chuyến bay")}</TableCell>
                      <TableCell align="center">{t("Tuyến bay")}</TableCell>
                    </>
                  )}
                  <TableCell align="center">{t("Lượng xuất bán")}</TableCell>
                  <TableCell align="center">{t("Đơn vị tính")}</TableCell>
                  <TableCell align="center">{t("Tiền tệ")}</TableCell>
                  <TableCell align="center">{t("Tổng tiền")}</TableCell>
                  <TableCell align="center">
                    <Button style={{ whiteSpace: "nowrap", minWidth: 140 }} disabled={!subData.length} color="secondary" variant="contained" onClick={handleSelectAll}>
                      {!isSelectedAll ? "Chọn tất cả" : "Bỏ chọn tất cả"}
                    </Button>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {subData.length ? (
                  subData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => (
                    <TableRow key={item.id} hover style={{ cursor: "pointer" }} selected={selectedInvoices.includes(item.id)} onClick={() => handleSelectCheckBox(item.id)}>
                      <TableCell align="center">{item.id}</TableCell>
                      <TableCell align="center">{item.serial}</TableCell>
                      <TableCell align="center">{item.code}</TableCell>
                      <TableCell align="center">{moment(item.valid_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell align="center">{t(item.saletype)}</TableCell>
                      {initialData.loadingtype?.id == 1 && (
                        <>
                          <TableCell align="center">{item.flight_no}</TableCell>
                          <TableCell align="center">{item.route}</TableCell>
                        </>
                      )}
                      <TableCell align="center">{Boolean(item.sub_quantity) && Math.round(item.sub_quantity)?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}</TableCell>
                      <TableCell align="center">{item.unit}</TableCell>
                      <TableCell align="center">{item.currency}</TableCell>
                      <TableCell align="right">{item.total?.toLocaleString(item.currency == "VND" ? "de-DE" : "ja-JP")}</TableCell>
                      <TableCell align="center">
                        <Checkbox checked={selectedInvoices.includes(item.id)} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={20} align="center">
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    count={subData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={setRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </div>

        <div style={{ marginTop: 20 }}>
          <Button onClick={() => goBack(0)} style={{ marginRight: "10px" }} color="secondary" variant="contained">
            {t("Quay lại")}
          </Button>
          <Button onClick={handleSubmit} variant="contained" disabled={!selectedInvoices.length}>
            {t("Tiếp tục")}
          </Button>
        </div>
      </div>
    );
  return <LoadingProgress />;
};

/**  */
const Step2 = ({ initialData, onSubmit, goBack }) => {
  const [t] = useTranslation();
  const [input, setInput] = useState({ ...initialData, ciproducts: initialData.ciproducts.sort((prev, next) => (prev.location > next.location ? 1 : -1)) });
  const inputRef = useValueRef(input);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const history = useHistory();
  const handleCheckbox = (index, value) => {
    const x = input.loadingtype?.id != 0;
    setInput((prev) => {
      let newValue = deepCopy(prev);
      let newPeriod;
      if (x && newValue.ciproducts[index].period !== "loading") newPeriod = value ? "loading" : null;
      newValue.ciproducts[index].period = newPeriod;
      let minPeriod = Math.min(...newValue.ciproducts.filter((i) => typeof i.period == "number").map((i) => i.period));
      if (minPeriod == Infinity) minPeriod = 0;
      newValue.ciproducts[index].isCreateBK = value;
      if (x) newValue.end_effective_time = moment(newValue.effective_time).add(minPeriod, "days").format("YYYY-MM-DD");
      return newValue;
    });
    if (!x || !value) return;
    getCHKSubso({
      customer_id: input.customer?.id,
      valid_date: input.period_start_time,
      // bank_id: input.bank?.id,
      saletype_id: input.ciproducts[index].saletype_id,
      loadingtype_id: input.loadingtype?.id,
      organization_id: input.ciproducts[index].organization_id,
      airline_id: input.ciproducts[index].airline_id,
    }).then((res) => {
      if (res.code == 200) {
        setInput((prev) => {
          let newValue = deepCopy(prev);
          let newPeriod = res.data && res.data?.period != null ? res.data.period : null;
          newValue.ciproducts[index].period = newPeriod;
          let minPeriod = Math.min(...newValue.ciproducts.filter((i) => typeof i.period == "number").map((i) => i.period));
          if (minPeriod == Infinity) minPeriod = 0;
          newValue.end_effective_time = moment(newValue.effective_time).add(minPeriod, "days").format("YYYY-MM-DD");
          return newValue;
        });
      }
    });
  };
  const handleCheckAll = () => {
    const x = input.loadingtype?.id != 0;
    if (input.ciproducts.some((i) => i.isCreateBK == false)) {
      // check all
      if (x)
        input.ciproducts.forEach((item, index) => {
          if (item.isCreateBK == false)
            getCHKSubso({
              customer_id: input.customer?.id,
              valid_date: input.period_start_time,
              saletype_id: item.saletype_id,
              loadingtype_id: input.loadingtype?.id,
              organization_id: item.organization_id,
              airline_id: item.airline_id,
            }).then((res) => {
              if (res.code == 200 && inputRef.current.ciproducts[index].isCreateBK == true)
                setInput((prev) => {
                  let newValue = deepCopy(prev);
                  let newPeriod = res.data && res.data?.period != null ? res.data.period : null;
                  newValue.ciproducts[index].period = newPeriod;
                  let minPeriod = Math.min(...newValue.ciproducts.filter((i) => typeof i.period == "number").map((i) => i.period));
                  if (minPeriod == Infinity) minPeriod = 0;
                  newValue.end_effective_time = moment(newValue.effective_time).add(minPeriod, "days").format("YYYY-MM-DD");
                  return newValue;
                });
            });
        });
      if (x) setInput((prev) => ({ ...prev, ciproducts: prev.ciproducts.map((i) => ({ ...i, isCreateBK: true, period: i.isCreateBK ? i.period : "loading" })) }));
      else setInput((prev) => ({ ...prev, ciproducts: prev.ciproducts.map((i) => ({ ...i, isCreateBK: true })) }));
    } else {
      setInput((prev) => ({ ...prev, ciproducts: prev.ciproducts.map((i) => ({ ...i, isCreateBK: false, period: null })), end_effective_time: x ? prev.effective_time : prev.end_effective_time }));
    }
  };
  const handleCIProductChange = (index, newValue) => {
    const newInput = deepCopy(input);
    newInput.ciproducts[index] = newValue;
    setInput(newInput);
  };
  const handleResponse = (res) => {
    if (res.code === 200) {
      let newCIProducts = input.ciproducts.filter((i) => !i.isCreateBK);
      if (newCIProducts.length) setInput((prev) => ({ ...prev, ciproducts: newCIProducts }));
      else history.push(`/ci/${res.data.id}`);
    }
  };
  return (
    <div>
      {/* Check Commercial Invoice/Proforma Invoice */}
      {input.type !== 1 && input.loadingtype_id == 5 && (
        <div>
          <FormControlLabel label="Commercial Invoice" control={<Checkbox checked={input.type === 0} onChange={() => setInput((prev) => ({ ...prev, type: 0 }))} />} sx={{ marginLeft: 1 }} />
          <FormControlLabel label="Proforma Invoice" control={<Checkbox checked={input.type === 2} onChange={() => setInput((prev) => ({ ...prev, type: 2 }))} />} sx={{ marginLeft: 1 }} />
        </div>
      )}

      <InvoiceViewer data={input} allowPrint={false} onCheckboxOnTable={handleCheckbox} onCIProductChange={handleCIProductChange} onCheckAll={handleCheckAll} />
      <Button variant="contained" color="secondary" style={{ marginRight: "10px" }} onClick={() => goBack(1)}>
        {t("Quay lại")}
      </Button>
      <Button onClick={() => setIsEditDialogOpen(true)} variant="contained" disabled={!input.ciproducts.filter((i) => i.isCreateBK).length || input.ciproducts.some((i) => i.period == "loading")}>
        {t("Tạo phiếu")}
      </Button>
      <EditCIDialog key={Boolean(isEditDialogOpen)} ciData={input} api={onSubmit} onClose={() => setIsEditDialogOpen(false)} open={isEditDialogOpen} onResponse={handleResponse} />
    </div>
  );
};

const EditCIDialog = ({ open, ciData, onClose, onResponse, api }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState({
    code: "",
    period: "",
  });
  const handleCreateCI = () => {
    return api({ ...ciData, ...input });
  };
  const handleResponse = (res) => {
    if (res.code == 200) {
      setInput({ code: "", period: "" });
      onClose?.();
      onResponse?.(res);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Nhập thông tin số CI/PN</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <TextField fullWidth label={t("Số CI/PN")} value={input.code} onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))} style={{ margin: "5px 0" }} />
        <TextField fullWidth label={t("Kỳ hóa đơn")} value={input.period} onChange={(e) => setInput((prev) => ({ ...prev, period: e.target.value }))} style={{ margin: "5px 0" }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICall variant="contained" api={handleCreateCI} response={handleResponse}>
          {t("Tạo phiếu")}
        </ButtonWithAPICall>
      </DialogActions>
    </Dialog>
  );
};

const EditShipInfoDialog = ({ open, initialData, onSave, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Nhập thông tin số tàu biển</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <TextField
          fullWidth
          label="Số hợp đồng"
          value={initialData?.ciinfos?.contract_no || ""}
          onChange={(e) => onSave((prev) => ({ ...prev, ciinfos: { ...prev.ciinfos, contract_no: e.target.value } }))}
          style={{ margin: "5px 0" }}
        />
        <TextField
          fullWidth
          label="Thoả thuận giao hàng"
          value={initialData?.ciinfos?.delivery_term || ""}
          onChange={(e) => onSave((prev) => ({ ...prev, ciinfos: { ...prev.ciinfos, delivery_term: e.target.value } }))}
          style={{ margin: "5px 0" }}
        />
        <TextField
          fullWidth
          label="Cảng dỡ"
          value={initialData?.ciinfos?.port_loading || ""}
          onChange={(e) => onSave((prev) => ({ ...prev, ciinfos: { ...prev.ciinfos, port_loading: e.target.value } }))}
          style={{ margin: "5px 0" }}
        />
        <TextField
          fullWidth
          label="Cảng nhận"
          value={initialData?.ciinfos?.port_discharge || ""}
          onChange={(e) => onSave((prev) => ({ ...prev, ciinfos: { ...prev.ciinfos, port_discharge: e.target.value } }))}
          style={{ margin: "5px 0" }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Lưu</Button>
      </DialogActions>
    </Dialog>
  );
};
